module.exports = __webpack_public_path__ + "static/img/14000461.f582fff3.png";